import React, { useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  TextField,
  IconButton,
  Grid,
  Paper,
  InputAdornment,
} from "@mui/material";
import { Edit, Delete, ChevronRight } from "@mui/icons-material";
import { Search } from "lucide-react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { deleteAddressById } from "../../Redux/AddressSlice";
import IMg from "../../images/main_image.png";
import { Address_url } from "../../api/urls";
import { useState } from "react";
import { api } from "../../api/api";
import { toast } from "react-toastify";


const AddressBook = () => {
      const user = useSelector((state) => state.auth.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();


  const [addresses, setAddresses] = useState([]);
const [loading, setLoading] = useState(true);
const [error, setError] = useState(null);



  const handleEdit = (address) => {
  navigate("/address", { state: { editAddress: address } });
};

useEffect(() => {
  const fetchAddresses = async () => {
    try {
      setLoading(true);
      const response = await api.get(Address_url(""));
      setAddresses(response.data || []);
    } catch (err) {
      setError(err.message || "Failed to load addresses");
    } finally {
      setLoading(false);
    }
  };

  fetchAddresses();
}, []);



const handleDelete = async (id) => {
  try {
    await api.delete(Address_url(id));
    setAddresses((prev) => prev.filter((item) => item.id !== id));
  } catch (err) {
    toast.error("Failed to delete address: " + err.message);
  }
};



  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100vh",
        p: 3,
        backgroundColor: "#f9f9f9",
        fontFamily: "Inter, sans-serif",
      }}
    >
      {/* Profile Heading */}
      <Box display="flex" alignItems="center" gap={2} mt={2} mb={4}>
        <img
          src={IMg}
          alt="profile"
          style={{ borderRadius: "50%", width: 60, height: 60 }}
        />
        <Box>
     <Typography sx={{ fontSize: "16px" }}>
                {user?.full_name || "Guest"}
              </Typography>
          
        </Box>
      </Box>

      {/* Section Title */}
      <Typography variant="h6" mt={2} mb={2}>
        Your Addresses
      </Typography>

      {/* Add Address Button */}
      <Button
        variant="outlined"
        fullWidth
        endIcon={<ChevronRight />}
        sx={{
          justifyContent: "space-between",
          mt: 2,
          mb: 3,
          backgroundColor: "#fff",
          border: "1px solid #000",
          color: "#000",
          fontFamily: "Inter, sans-serif",
          "&:hover": {
            backgroundColor: "#f0f0f0",
            border: "1px solid #000",
          },
        }}
        onClick={() => navigate("/address")}
      >
        Add New Address
      </Button>

      {/* Search Input */}
      <Box mt={2} mb={4}>
        <TextField
          fullWidth
          placeholder="Search"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton>
                  <Search />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Box>

   
      <Grid container spacing={2}>
  {addresses.length > 0 ? (
    addresses.map((formData, index) => (
      <Grid item xs={12} md={6} key={formData.id || index}>
        <Paper
          elevation={2}
          sx={{
            p: 2,
            borderRadius: 2,
            border: "1px solid #e0e0e0",
            backgroundColor: "#fff",
            mt: 2,
            mb: 2,
          }}
        >
          <Box display="flex" justifyContent="space-between">
            <Box>
              <Typography fontWeight={600} fontSize="14px" gutterBottom>
                {formData.name}
              </Typography>
              <Typography variant="body2" sx={{ whiteSpace: "pre-line" }}>
                {`${formData.address}, ${formData.address_two || ""}\n${
                  formData.city
                }, ${formData.state || formData.state_name || ""}\n${
                  formData.pincode
                } ${formData.country || "India"}\nPhone Number: ${
                  formData.phone || formData.primary_mobile
                }`}
              </Typography>
            </Box>

            <Box display="flex" gap={1} alignItems="start">
              {/* <IconButton
                size="small"
                onClick={() =>
                  navigate("/address", { state: { editAddress: formData } })
                }
              >
                <Edit fontSize="small" />
              </IconButton>
              <IconButton
                size="small"
                onClick={() => dispatch(deleteAddressById(formData.id))}
              >
                <Delete fontSize="small" sx={{ color: "red" }} />
              </IconButton> */}
              <IconButton size="small" onClick={() => handleEdit(formData)}>
  <Edit fontSize="small" />
</IconButton>

<IconButton size="small" onClick={() => handleDelete(formData.id)}>
  <Delete fontSize="small" sx={{ color: "red" }} />
</IconButton>

            </Box>
          </Box>
        </Paper>
      </Grid>
    ))
  ) : (
    <Grid item xs={12} mt={2}>
      <Typography color="gray">No address found. Please add one.</Typography>
    </Grid>
  )}
</Grid>

    </Box>
  );
};

export default AddressBook;
